import { render, staticRenderFns } from "./_4.vue?vue&type=template&id=b5276fec&scoped=true&"
import script from "./_4.vue?vue&type=script&lang=js&"
export * from "./_4.vue?vue&type=script&lang=js&"
import style0 from "./_4.vue?vue&type=style&index=0&id=b5276fec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5276fec",
  null
  
)

export default component.exports